<template>
  <div :class="customClass">
    <i class="mdi mdi-check text-success" v-if="formatValue == true"></i>
    <i class="mdi mdi-close text-primary" v-if="formatValue == false"></i>
    <i class="mdi mdi-checkbox-blank-circle-outline text-dark" v-if="formatValue == null"></i>
  </div>
</template>
<script>
import _ from 'lodash';

/**
 * COMPONENTE DE CELDA DE TABLA PARA MOSTRAR LOS BOOLEANOS
 * SE PUEDE USAR EN LAS TABLAS O EN OTRO SITIO.
 * */
export default {
  name: 'cell-dt-boolean-type',
  data() {
    return {};
  },
  props: ['value', 'outcomes', 'format'],
  computed: {
    /**
     * Función formatear los números.
     * */
    formatValue() {
      if (this.value == null) {
        return null;
      } else if (_.isBoolean(this.value)) {
        return this.value;
      } else {
        const val = Boolean(this.value);

        return val;
      }
    },
    customClass() {
      let cellClass = 'cellBooleanType';
      if (this.classToApply) {
        cellClass += ` ${this.classToApply}`;
      }
      return cellClass;
    },
  },
  methods: {},
};
</script>
<style scoped>
.cellBooleanType {
  text-align: center;
}
</style>
